module.exports = __webpack_public_path__ + "static/avatar_of_death-20419fdb1c88ee46528222bd099bab08.png";